export default function GameShopIcon({
  size = 16,
  width,
  height,
  ...rest
}: {
  size?: number;
  width?: number;
  height?: number;
  [key: string]: any;
}) {
  return (
    <svg
      {...rest}
      width={width || size}
      height={height || width}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17178_17770)">
        <path
          d="M12.24 6.0013L12.64 8.0013H3.36L3.76 6.0013H12.24ZM13.3333 2.66797H2.66667V4.0013H13.3333V2.66797ZM13.3333 4.66797H2.66667L2 8.0013V9.33464H2.66667V13.3346H9.33333V9.33464H12V13.3346H13.3333V9.33464H14V8.0013L13.3333 4.66797ZM4 12.0013V9.33464H8V12.0013H4Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_17178_17770">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
